import "./style.moduleRenamed.css";

export const configItem = "style-module__configItem___o9o9X";
export const methodParams = "style-module__methodParams___AZ1B0";
export const input = "style-module__input___Umqwm";
export const primaryColor = "style-module__primaryColor___oEqsX";
export const initForm = "style-module__initForm___1BiMW";
export const setter = "style-module__setter___U78oN";
export const key = "style-module__key___AumRb";
export const btn = "style-module__btn___g04yp";
export const requestForm = "style-module__requestForm___yVw-T";
export const settings = "style-module__settings___wnR-7";
export const formLabel = "style-module__formLabel___kSSf-";
export const tip = "style-module__tip___LTII0";
export const defaultValue = "style-module__defaultValue___1x5aH";
export const formItem = "style-module__formItem___nH5m2";
export const invokeItem = "style-module__invokeItem___OEMhy";
export const methodName = "style-module__methodName___NN-MS";
export const edit = "style-module__edit___F4In-";
export const tooltip = "style-module__tooltip___DPMAf";
export const highlight = "style-module__highlight___RB1wT";
export const dsHighlight = "style-module__dsHighlight___wSR5x";

export default {
  configItem: "style-module__configItem___o9o9X",
  methodParams: "style-module__methodParams___AZ1B0",
  input: "style-module__input___Umqwm",
  primaryColor: "style-module__primaryColor___oEqsX",
  initForm: "style-module__initForm___1BiMW",
  setter: "style-module__setter___U78oN",
  key: "style-module__key___AumRb",
  btn: "style-module__btn___g04yp",
  requestForm: "style-module__requestForm___yVw-T",
  settings: "style-module__settings___wnR-7",
  formLabel: "style-module__formLabel___kSSf-",
  tip: "style-module__tip___LTII0",
  defaultValue: "style-module__defaultValue___1x5aH",
  formItem: "style-module__formItem___nH5m2",
  invokeItem: "style-module__invokeItem___OEMhy",
  methodName: "style-module__methodName___NN-MS",
  edit: "style-module__edit___F4In-",
  tooltip: "style-module__tooltip___DPMAf",
  highlight: "style-module__highlight___RB1wT",
  dsHighlight: "style-module__dsHighlight___wSR5x",
};